function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Icon - Plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5-7H1v-4.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V-7h-4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H-1v4.5a.5.5 0 0 0 .5.5h1A.5.5 0 0 0 1-.5V-5h4.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z",
    transform: "translate(12 18)",
    style: {
      fill: "#4080c0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusActive);
export default __webpack_public_path__ + "static/media/IconPlusActive.bddcf9ad8f643051f5c6998fa697b61e.svg";
export { ForwardRef as ReactComponent };